const WELCOME_SCREEN_PROPS = Object.freeze({
    title: 'title',
    description: 'description',
    show_button: 'show_button',
    show_screen: 'show_screen',
    button_text: 'button_text'
})

export default WELCOME_SCREEN_PROPS